/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Growl } from 'primereact/growl'

import LoginComponent from '../components/LoginComponent'
import { userActions } from '../_actions'
import { messageConstants } from '../_constants'

function LoginContainer({ user, authentication, login, forgotPasswordError, forgotPasswordSuccess, forgotPassword, message }) {
  console.log(authentication)
  const history = useHistory()
  useEffect(() => {
    if (authentication.error) {
      showLoginErrorGrowl(authentication.message)
    }
    if (userActions.getCurrentToken() && userActions.getCurrentToken() !== '') {
      history.push('/dashboard')
    }
    if (forgotPasswordError) {
      showForgotPasswordErrorGrowl()
    }
    if (forgotPasswordSuccess) {
      showForgotPasswordSuccessGrowl()
    }
  }, [user, authentication, forgotPasswordError, forgotPasswordSuccess])
  const growl = useRef()
  const showLoginErrorGrowl = (message) => {
    growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: message, life: 400 })
  }
  const showForgotPasswordSuccessGrowl = () => {

    growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: messageConstants.successMessages.forgotPassword, life: 400 })
  }
  const showForgotPasswordErrorGrowl = () => {

    growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: messageConstants.errorMessages.forgotPassword, life: 400 })
  }
  return (<>
    <Growl ref={growl} />
    <LoginComponent
      user={user}
      login={login}
      authentication={authentication}
      forgotPassword={forgotPassword}

    />

  </>
  )
}
LoginContainer.propTypes = {
  user: PropTypes.object,
  error: PropTypes.object,
  authentication: PropTypes.object,
  login: PropTypes.func,
  forgotPasswordError: PropTypes.object,
  forgotPasswordSuccess: PropTypes.object,
  forgotPassword: PropTypes.func,
}
const mapStateToProps = state => {
  console.log(state.users)
  return {
    user: state.users.user,
    authentication: state.authentication,
    forgotPasswordError: state.users.forgotPasswordError,
    forgotPasswordSuccess: state.users.forgotPasswordSuccess
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (username, password) => dispatch(userActions.login(username, password)),
    forgotPassword: (emailAddress) => dispatch(userActions.forgotPassword(emailAddress)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
